export default __webpack_public_path__ + "static/cropncarryWatermarkLogo-a5faef6286f59f1ec019325820810688.png";